import { CreateAppointmentDataDomain } from './CreateAppointmentMapper.types'
import { format } from 'date-fns'

class CreateAppointmentMapper {
  toPersistence(domainCreateAppointmentData: CreateAppointmentDataDomain) {
    const isObjectException =
      domainCreateAppointmentData?.appointmentRecurrenceParams
        ?.appointmentObject === 'AGENDAMENTO_POR_EXCECAO'

    const appointmentExceptionPayload = {
      idUsuarioResponsavel:
        domainCreateAppointmentData?.appointmentRecurrenceParams
          ?.appointmentException?.reponsibleUserId,
      dataAutorizacao: domainCreateAppointmentData?.appointmentRecurrenceParams
        ?.appointmentException?.authorizationDate
        ? format(
            domainCreateAppointmentData?.appointmentRecurrenceParams
              ?.appointmentException?.authorizationDate,
            'dd/MM/yyyy',
          )
        : null,
      motivoExcecao:
        domainCreateAppointmentData?.appointmentRecurrenceParams
          ?.appointmentException?.exceptionReason,
    }

    const appointmentRecurrencePayload = {
      dataInicio:
        domainCreateAppointmentData?.appointmentRecurrenceParams?.startDate,
      flagAtendimentoEncaixe:
        domainCreateAppointmentData?.appointmentRecurrenceParams
          ?.fittingAppointment,
      objetivoAtendimento:
        domainCreateAppointmentData?.appointmentRecurrenceParams
          ?.appointmentObject,
      idAgendamentoPV:
        domainCreateAppointmentData?.appointmentRecurrenceParams
          ?.appointmentPvId,
      agendamentoPorExcecao: appointmentExceptionPayload,
    }

    const isMultipleHeathInsurance =
      domainCreateAppointmentData?.multipleHealthInsuranceCards

    const payload = {
      idPaciente: domainCreateAppointmentData?.patientId,
      idProfissional: domainCreateAppointmentData?.professionalId,
      atendimentoRecorrenteParams: appointmentRecurrencePayload,
      idPatientHealthInsurance: isMultipleHeathInsurance
        ? domainCreateAppointmentData?.healthInsuranceId
        : null,
    }

    if (!isMultipleHeathInsurance) {
      delete payload.idPatientHealthInsurance
    }

    if (!isObjectException) {
      delete payload.atendimentoRecorrenteParams.agendamentoPorExcecao
    }

    return payload
  }
}

export default new CreateAppointmentMapper()
